module.exports = __webpack_public_path__ + "static/rappler-plus-dark-9111d2966ddb13d8ac205a8706a4c589.png";